// shared-components/context/WebsiteContext.tsx
import type {
  WebsiteContextValue,
  WebsiteProviderProps,
} from "../types/WebsiteTypes";
import { WebsiteContext } from "./WebsiteContextDefinition";

// Provider component that accepts both websiteId and websiteConfig
export const WebsiteProvider = ({
  websiteId,
  websiteConfig = null,
  children,
}: WebsiteProviderProps) => {
  // If no websiteConfig is provided, fall back to just the websiteId for backward compatibility
  const contextValue: WebsiteContextValue = websiteConfig
    ? { ...websiteConfig, websiteId }
    : ({ websiteId } as WebsiteContextValue);

  return (
    <WebsiteContext.Provider value={contextValue}>
      {children}
    </WebsiteContext.Provider>
  );
};
